import { jsx as _jsx } from "react/jsx-runtime";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useRef } from "react";
import clsx from "clsx";
import { useDroppable } from "../internal/dnd-controller/controller";
import { getDefaultColumnSpan, getDefaultRowSpan } from "../internal/utils/layout";
import styles from "./styles.css.js";
export default function Placeholder({ id, state, gridContext, columns }) {
    const ref = useRef(null);
    const dropTargetContext = {
        scale: (item, size) => {
            var _a, _b;
            const width = (_a = size === null || size === void 0 ? void 0 : size.width) !== null && _a !== void 0 ? _a : getDefaultColumnSpan(item, columns);
            const height = (_b = size === null || size === void 0 ? void 0 : size.height) !== null && _b !== void 0 ? _b : getDefaultRowSpan(item);
            return {
                width: gridContext.getWidth(width),
                height: gridContext.getHeight(height),
            };
        },
    };
    useDroppable({ itemId: id, context: dropTargetContext, getElement: () => ref.current });
    return _jsx("div", { ref: ref, className: clsx(styles.placeholder, styles[`placeholder--${state}`]) });
}
//# sourceMappingURL=placeholder.js.map